import { call, put } from 'redux-saga/effects';
import api from '../../../services/api';
import { setCompanyTags } from '../actions';

export function* loadCompanyTagsWorker(companyID: string) {
  if (!companyID) {
    throw new Error('Failed to load tags. There are missed params.');
  }

  try {
    const {
      data: { Data },
    } = yield call(api.get, `/v1/companies/${companyID}/company-tag`);

    yield put(setCompanyTags(Data));
  } catch (err) {
    console.log('Failed to load company tags: ', err);
  }
}
